var exports = {
  "kL": "ChannelPinsPopout.module__container___M2pRdl",
  "wx": "ChannelPinsPopout.module__header___M2pRdl",
  "rf": "ChannelPinsPopout.module__body___M2pRdl",
  "DD": "ChannelPinsPopout.module__title___M2pRdl",
  "J3": "ChannelPinsPopout.module__iconLarge___M2pRdl",
};

module.exports = exports;
